import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons'; // Ikony marek (media społecznościowe)

// Dodaj ikony do biblioteki
library.add(fab);

const app = createApp(App);
app.use(router);
app.component('font-awesome-icon', FontAwesomeIcon); // Rejestracja komponentu
app.mount('#app');